export default __webpack_public_path__ + "static/media/candle.2431096e.png";